import type { FoodTemplate } from '@/api/types/nutrition'

/** 食事シートのタブ */
export type SheetTab = 'search' | 'ai' | 'favorites' | 'history' | 'db'

/** 検索以外のタブ（記録バーのボタンから、シートをそのタブで開ける） */
export type FoodListKind = Exclude<SheetTab, 'search'>

/** 食事シートをどの状態で開くか（記録バーから開くとき） */
export type SheetInit = {
  tab: SheetTab
  /** AI 入力欄に入れておく文字 */
  memo?: string
  /** DB タブで最初に検索する文字 */
  dbQuery?: string
}

/** 全角/半角・大文字/小文字・カタカナ/ひらがなの違いを無視して比べられる形にする */
export function normalizeForSearch(text: string): string {
  return text
    .normalize('NFKC')
    .toLowerCase()
    .replace(/[\u30a1-\u30f6]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0x60))
    .replace(/\s+/g, ' ')
    .trim()
}

function lastUsedTime(t: FoodTemplate): number {
  return t.last_used_at ? Date.parse(t.last_used_at) : 0
}

/** よく使う順（回数 → 最近使った順） */
function byFrequentUse(a: FoodTemplate, b: FoodTemplate): number {
  return b.use_count - a.use_count || lastUsedTime(b) - lastUsedTime(a)
}

/**
 * パレットに出すお気に入りを選ぶ。
 * 空欄ならよく使う順、入力があればお気に入り名か中の食品名に含まれるものをよく使う順で返す
 */
export function pickPaletteTemplates(templates: FoodTemplate[], query: string, limit: number): FoodTemplate[] {
  const keyword = normalizeForSearch(query)
  const matched = keyword
    ? templates.filter(
        (t) =>
          normalizeForSearch(t.name).includes(keyword) ||
          t.items.some((item) => normalizeForSearch(item.name).includes(keyword)),
      )
    : templates
  return [...matched].sort(byFrequentUse).slice(0, limit)
}
